<template>
  <router-link class="navbar-brand" :class="brandClass" :to="to">
    <img
      class="align-top"
      :class="imgClass"
      :style="imgStyle"
      :src="computedSrc"
      :alt="alt"
      :onerror="onerror"
    />
  </router-link>
</template>

<script lang="ts">
import { Options, prop, Vue } from "vue-class-component";
import { configurations } from "@/store/modules/hotel/configuration";

class Props {
  to = prop<string>({ default: "/home" });
  src = prop<string>({ default: "" });
  alt = prop<string>({ default: "" });
  brandClass = prop<string>({ default: "" });
  imgClass = prop<string>({ default: "brand-logo" });
  imgStyle = prop<string>({ default: "" });
  logoFolder = prop<string>({ default: "main/configuration/logo/mobile" });
  fallbackSrc = prop<string>({ default: "" });
}

@Options({})
class BrandLogo extends Vue.with(Props) {
  private config = configurations();

  get computedSrc(): string {
    return this.src || this.$getWebImage(this.config.getLogo, this.logoFolder);
  }

  get onerror(): string | null {
    return this.fallbackSrc ? `this.onerror=null; this.src='${this.fallbackSrc}';` : null;
  }
}
export default BrandLogo;
</script>

<style lang="scss" scoped>
.navbar-brand {
  transition: all 0.3s ease;
}

.brand-logo {
  transition: transform 0.3s ease;
  .navbar-brand:hover & {
    transform: scale(1.05);
  }
}
</style>
